var _g, _g2, _g3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJoinExperts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 62,
    viewBox: "0 0 60 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4516_13231)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 48,
    height: 48,
    rx: 10,
    fill: "url(#paint0_linear_4516_13231)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_4516_13231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.13086 11.7218C10.6961 9.63485 12.783 5.46094 21.6513 5.46094C29.094 5.46094 33.7331 5.46094 39.3276 5.46094C44.9222 5.46094 49.4091 8.41746 50.9743 11.7218",
    stroke: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4516_13231)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.003 20C33.747 20 34.533 20.26 35.253 20.547L35.78 20.763C37.04 21.291 37.748 22.399 38.297 23.616C39.188 25.591 39.807 28.224 40.021 30.226C40.123 31.176 40.148 32.132 39.965 32.775C39.768 33.462 39.098 33.948 38.447 34.33L38.125 34.513L37.791 34.699C37.619 34.795 37.442 34.89 37.266 34.983L36.744 35.253L36.027 35.61L35.45 35.894C35.3321 35.9576 35.2027 35.9968 35.0694 36.0094C34.936 36.022 34.8015 36.0077 34.6738 35.9673C34.5462 35.9269 34.4279 35.8613 34.326 35.7743C34.2242 35.6874 34.1408 35.5808 34.0809 35.461C34.0211 35.3413 33.9858 35.2107 33.9774 35.077C33.9689 34.9433 33.9874 34.8094 34.0317 34.683C34.076 34.5566 34.1452 34.4404 34.2353 34.3413C34.3254 34.2422 34.4344 34.1622 34.556 34.106L35.346 33.716L34.766 33.107C33.376 33.677 31.739 34 30 34C28.261 34 26.624 33.678 25.234 33.107L24.654 33.715L25.447 34.105C25.5645 34.1637 25.6694 34.245 25.7555 34.3442C25.8416 34.4434 25.9074 34.5586 25.949 34.6832C25.9906 34.8078 26.0072 34.9394 25.9979 35.0705C25.9887 35.2015 25.9537 35.3295 25.895 35.447C25.8363 35.5645 25.755 35.6694 25.6558 35.7555C25.5566 35.8416 25.4414 35.9073 25.3168 35.9489C25.0651 36.033 24.7904 36.0136 24.553 35.895L24.009 35.625C23.607 35.425 23.204 35.227 22.806 35.018L21.878 34.513L21.557 34.33C20.906 33.948 20.235 33.462 20.039 32.775C19.855 32.132 19.881 31.177 19.982 30.225C20.196 28.224 20.815 25.591 21.706 23.616C22.255 22.399 22.963 21.291 24.223 20.763C25.059 20.413 26.072 20 27 20C27.603 20 28.077 20.555 27.99 21.147C28.6555 21.0485 29.3273 20.9994 30 21C30.691 21 31.366 21.05 32.014 21.148C31.9947 21.006 32.0059 20.8615 32.0466 20.7241C32.0874 20.5867 32.1568 20.4595 32.2504 20.351C32.344 20.2425 32.4596 20.1551 32.5895 20.0946C32.7194 20.034 32.8607 20.0018 33.004 20H33.003ZM26.75 26.5C26.2859 26.5 25.8408 26.6844 25.5126 27.0126C25.1844 27.3408 25 27.7859 25 28.25C25 28.7141 25.1844 29.1592 25.5126 29.4874C25.8408 29.8156 26.2859 30 26.75 30C27.2141 30 27.6593 29.8156 27.9875 29.4874C28.3156 29.1592 28.5 28.7141 28.5 28.25C28.5 27.7859 28.3156 27.3408 27.9875 27.0126C27.6593 26.6844 27.2141 26.5 26.75 26.5ZM33.25 26.5C32.7859 26.5 32.3408 26.6844 32.0126 27.0126C31.6844 27.3408 31.5 27.7859 31.5 28.25C31.5 28.7141 31.6844 29.1592 32.0126 29.4874C32.3408 29.8156 32.7859 30 33.25 30C33.7141 30 34.1593 29.8156 34.4875 29.4874C34.8156 29.1592 35 28.7141 35 28.25C35 27.7859 34.8156 27.3408 34.4875 27.0126C34.1593 26.6844 33.7141 26.5 33.25 26.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4516_13231",
    x: 0,
    y: 2,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4516_13231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4516_13231",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_4516_13231",
    x: 4.73047,
    y: 0.960938,
    width: 50.6953,
    height: 15.061,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_4516_13231"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4516_13231",
    x1: 30,
    y1: 4,
    x2: 30,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#915DF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4516_13231"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(18 16)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinExperts);
export default __webpack_public_path__ + "static/media/join_experts.06a8ccb7b59d06108f888f5a86e2d4d8.svg";
export { ForwardRef as ReactComponent };